import { json } from "../../../libs/utils/Const";
import { calcultateOperationHeader } from "../../../libs/utils/GlobalFunc";

export const checkWithHolding = async (ctx, newOrderModel = {}) => {
    const { view, action, getUserFieldHeaderValue } = ctx.props;
    const { editMode } = ctx.state;
    try {
        if ((newOrderModel.RetencionVista || newOrderModel?.newView === 'PurchaseOrder') && (Number(action) === 1 || (Number(action) === 2 && editMode))) {
            const { U_FMB_BP_Reten = 'N', U_STR_BC = 'N', U_STR_AR = 'N', U_STR_AP = 'N', Total = 0, totalPago = 0, newView = '', Items = [], LicTradNum = '', U_BPP_BPTD = -1, ItemsPayments = [], DocCur = 'SOL' } = newOrderModel || {};
            const docView = newView || view;
            const isOutgoingPayment = docView === 'outgoingPayment';
            const isU_FMB_BP_Reten = U_FMB_BP_Reten === 'Y';    // El socio tiene retención
            const isU_STR_BC = U_STR_BC === 'Y';                // El socio es buen contribuyente
            const isU_STR_AR = U_STR_AR === 'Y';                // El socio es agente de retención
            const isU_STR_AP = U_STR_AP === 'Y';                // El socio es agente de percepción
            const isIGV = Items?.some((item) => !item?.TaxCode?.includes("EXO") && (item.TaxCode?.includes("IGV") || item.TaxName?.toUpperCase()?.includes("IGV")));
            const isDetraccion = newOrderModel?.U_STR_AfctoDtr === 'Y' || Items?.some((item) => item?.U_RML_AFEDET === 'Y');

            let totalConvert = !isOutgoingPayment ? calcultateOperationHeader(newOrderModel) : { totalLocal: 0 };
            totalConvert = Number(totalConvert?.totalLocal || 0) || 0;

            let totalPagoConvert = isOutgoingPayment ? calcultateOperationHeader(newOrderModel, true) : { totalLocal: 0 };
            totalPagoConvert = Number(totalPagoConvert?.totalLocal || 0) || 0;

            const documentTotal = !isOutgoingPayment && Number(totalConvert || 0) > 700;
            const documentPaymentTotal = isOutgoingPayment && Number(totalPagoConvert || 0) > 700;
            const RUC = LicTradNum && Number(U_BPP_BPTD || -1) === 6; // El socio tenga RUC y el tipo de documento sea RUC -> Contribuyente nacional

            //#region Importación
            let importacion = false;
            const aliasToFind = "U_tipoOpT12";
            const headers = newOrderModel?.userFieldsBody || [];
            const cleanAlias = aliasToFind?.startsWith("U_") ? aliasToFind?.slice(2) : aliasToFind;
            const bodyMatch = headers?.find(h => h.header?.AliasID === cleanAlias);

            if (bodyMatch) {
                const fieldId = bodyMatch?.header?.FieldID;
                const options = bodyMatch?.options || [];
                const allFields = json?.allItemsUserFields || [];
                const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);

                if (foundIndex !== -1) {
                    const fieldNumber = foundIndex + 1;
                    const importacionValue = options?.find(option => option?.Descr?.toUpperCase() === 'IMPORTACIÓN' || option?.Descr?.toUpperCase() === 'IMPORTACION')?.FldValue || '';
                    importacion = Items?.some((item) => item?.UserFieldsItem[`userFields${fieldNumber}`] === importacionValue);
                }
            }
            importacion = !importacion ? newOrderModel?.U_RS_IMP === 'Y' || newOrderModel?.U_RS_IMP === true : importacion;
            //#endregion Tipo de operacion

            const U_BPP_MDTD = docView === 'purchaseInvoice' ? getUserFieldHeaderValue('U_BPP_MDTD', newOrderModel) : -1;
            const is01 = docView === 'purchaseInvoice' ? Number(U_BPP_MDTD || -1) === 1 : false;
            const existWithHolding = isOutgoingPayment && ItemsPayments?.some((item) => item?.U_LLG_RETENCI === 'Y');

            if (isU_FMB_BP_Reten && // El socio tiene retención
                !isU_STR_BC &&      // El socio no debe de ser buen contribuyente
                !isU_STR_AR &&      // El socio no debe de ser agente de retención
                !isU_STR_AP &&      // El socio no debe de ser agente de percepción
                (
                    ( // Aqui es para compras
                        !isOutgoingPayment &&   // No es pago efectuado
                        isIGV &&                // Alguna linea tiene IGV
                        documentTotal &&        // Total mayor a 700
                        !isDetraccion &&        // Ninguna linea del documento es detraccion
                        RUC &&                  // El socio tiene un RUC
                        !importacion &&         // No corresponde a una importacion
                        (
                            (docView === 'purchaseInvoice' && is01) // En caso de ser factura debe de ser de tipo 01
                            || !docView !== 'purchaseInvoice'
                        )
                    )
                    ||
                    ( // Aqui es para pago efectuado
                        isOutgoingPayment &&            // Es pago efectuado
                        (
                            documentPaymentTotal        // Total mayor a 700
                            ||
                            (!documentPaymentTotal &&   // El monto es menor o igual a 700
                                existWithHolding        // La factura aplico a retención
                            )
                        )
                    )
                )
            ) { // Aplica a retención
                newOrderModel.U_LLG_RETENCI = 'Y';
                if (isOutgoingPayment && documentPaymentTotal && !existWithHolding) {
                    newOrderModel.WithHoldingPrev = true; // Cuando es pago efectuado con total mayor a 700 pero ninguna factura tuvo retención, no permitir crear el pago (No es posible crear retenciones)
                } else {
                    newOrderModel.WithHoldingPrev = false;
                }
                if (!isOutgoingPayment) {
                    newOrderModel.MONRET = Number((Number(Total || 0) * (0.03))?.toFixed(2));
                } else {
                    newOrderModel.MONRET = 0;
                }
            } else { // No aplica a retención
                newOrderModel.U_LLG_RETENCI = 'N';
                newOrderModel.MONRET = 0;
            }
        }
    } catch (error) {
        // console.log('checkWithHolding -> Error:', error);
    }
    return newOrderModel;
}